export const validateForm2 = (form2) => {
  return { validationResult: {}, form: form2 };
};
